import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import Popup from '@atlaskit/popup';
import { Inline, xcss } from '@atlaskit/primitives';
import React, { useCallback, useState } from 'react';
import { Reaction } from '../Reaction';
import { ReactionSummaryButton } from './ReactionSummaryButton';
var summaryPopupStyles = xcss({
  padding: 'space.100',
  paddingTop: 'space.050',
  maxWidth: '325px'
});

/**
 * Test id for the Reactions summary view popup
 */
export var RENDER_SUMMARY_VIEW_POPUP_TESTID = 'render-summary-view-popup';
export var ReactionSummaryView = function ReactionSummaryView(_ref) {
  var emojiProvider = _ref.emojiProvider,
    _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$flash = _ref.flash,
    flash = _ref$flash === void 0 ? {} : _ref$flash,
    _ref$particleEffectBy = _ref.particleEffectByEmoji,
    particleEffectByEmoji = _ref$particleEffectBy === void 0 ? {} : _ref$particleEffectBy,
    handleOpenReactionsDialog = _ref.handleOpenReactionsDialog,
    allowUserDialog = _ref.allowUserDialog,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto-start' : _ref$placement,
    onReactionClick = _ref.onReactionClick,
    onReactionFocused = _ref.onReactionFocused,
    onReactionMouseEnter = _ref.onReactionMouseEnter,
    _ref$showOpaqueBackgr = _ref.showOpaqueBackground,
    showOpaqueBackground = _ref$showOpaqueBackgr === void 0 ? false : _ref$showOpaqueBackgr,
    _ref$subtleReactionsS = _ref.subtleReactionsSummaryAndPicker,
    subtleReactionsSummaryAndPicker = _ref$subtleReactionsS === void 0 ? false : _ref$subtleReactionsS;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSummaryPopupOpen = _useState2[0],
    setSummaryPopupOpen = _useState2[1];
  var handlePopupClose = useCallback(function () {
    return setSummaryPopupOpen(false);
  }, []);
  var handleSummaryClick = useCallback(function () {
    return setSummaryPopupOpen(!isSummaryPopupOpen);
  }, [isSummaryPopupOpen]);
  return /*#__PURE__*/React.createElement(Popup, {
    placement: placement,
    content: function content() {
      return /*#__PURE__*/React.createElement(Inline, {
        xcss: summaryPopupStyles,
        testId: RENDER_SUMMARY_VIEW_POPUP_TESTID,
        space: "space.025",
        shouldWrap: true
      }, reactions.map(function (reaction) {
        return /*#__PURE__*/React.createElement(Reaction, {
          key: reaction.emojiId,
          reaction: reaction,
          emojiProvider: emojiProvider,
          onClick: onReactionClick,
          onFocused: onReactionFocused,
          onMouseEnter: onReactionMouseEnter,
          flash: flash[reaction.emojiId],
          handleUserListClick: handleOpenReactionsDialog,
          allowUserDialog: allowUserDialog,
          showParticleEffect: particleEffectByEmoji[reaction.emojiId]
        });
      }));
    },
    isOpen: isSummaryPopupOpen,
    onClose: handlePopupClose,
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(ReactionSummaryButton, _extends({}, triggerProps, {
        emojiProvider: emojiProvider,
        reactions: reactions,
        onClick: handleSummaryClick,
        showOpaqueBackground: showOpaqueBackground,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker
      }));
    }
  });
};